import { render, staticRenderFns } from "./ModalEditarCarpeta.vue?vue&type=template&id=d5c8daf0"
import script from "./ModalEditarCarpeta.vue?vue&type=script&lang=js"
export * from "./ModalEditarCarpeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports